import { Quest } from 'types/quests'
import useStore, { PendingOptimisticAnswerRef } from 'state/knovStore'
import { cacheQuest } from 'state/cache'

const PENDING_OPTIMISTIC_ANSWER_TTL_MS = 20_000

export const getFreshPendingOptimisticAnswerIdsForQuest = (
    questId: string | number | null | undefined,
) => {
    if (questId == null) return []
    const refs: PendingOptimisticAnswerRef[] =
        useStore.getState().pendingOptimisticAnswersByQuest?.[String(questId)] || []
    if (!refs.length) return []
    const cutoff = Date.now() - PENDING_OPTIMISTIC_ANSWER_TTL_MS
    return refs
        .filter(ref => typeof ref?.createdAtMs === 'number' && ref.createdAtMs >= cutoff)
        .map(ref => String(ref.answerId))
}

export const cacheQuestPreservingPendingOptimisticAnswers = (
    quest: Quest,
    options: Parameters<typeof cacheQuest>[1] = {},
) => {
    if (!quest?.id) return cacheQuest(quest, options)
    const questId = String(quest.id)
    const preserveIds = getFreshPendingOptimisticAnswerIdsForQuest(questId)
    const cachedQuest = cacheQuest(quest, { ...options, preserveAnswerIds: preserveIds })

    if (preserveIds.length) {
        const serverIds = new Set(
            [
                ...(Array.isArray(quest.sorted_answer_ids) ? quest.sorted_answer_ids : []),
                ...(Array.isArray(quest.sorted_answers)
                    ? quest.sorted_answers.map(answer => answer?.id)
                    : []),
            ]
                .filter(Boolean)
                .map(id => String(id)),
        )
        preserveIds.forEach(id => {
            if (serverIds.has(String(id))) {
                useStore.getState().resolvePendingOptimisticAnswer(questId, String(id))
            }
        })
    }

    return cachedQuest
}
